<template>
  <div>
    <!-- 筛选项 -->
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" width="100px" :mdSpan="6" :flexFlag="true">
      <!-- <div class="component_title2">筛选项</div> -->
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="时间">
          <dataPicker :datevalue.sync="searchForm.time" :clearFlag="true"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="项目" prop="project">
          <SelectCustomizeNew :value="projectInfo" @changeScope="changeArticle" :data="article_id" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="应用" prop="appid">
          <SelectCustomizeNew :value="appidInfo" @changeScope="changeAppid" :data="apps" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-popover placement="top-end" width="200" trigger="hover" content="仅在选择一个应用时可用" :disabled="versionPopover">
          <el-form-item label="版本号" prop="versionNum" slot="reference">
            <!-- <SelectCustomize /> -->
            <el-select v-model="searchForm.versionNum" placeholder="请选择" :disabled="versionDisabled" multiple
              collapse-tags clearable>
              <el-option v-for="(item, ind) in versionV2" :key="ind" :value="item" :label="item" />
            </el-select>
          </el-form-item>
        </el-popover>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="系统" prop="system">
          <SelectCustomizeNew :value="systemInfo" @changeScope="changeSystem" :data="systemIds" />
        </el-form-item>
      </el-col>

      <!-- <el-col :md="6" :sm="12">
        <el-form-item label="审核异常平台">
          <el-cascader v-model="searchForm.auditException" :options="second_channels" :props="cascaderProps" clearable
            @change="cascderChange" placeholder="请选择" style="width: 263px" collapse-tags filterable></el-cascader>
        </el-form-item>
      </el-col> -->
      <el-col :md="6" :sm="12">
        <el-form-item label="产品负责人">
          <el-select placeholder="请选择" v-model="searchForm.responsible" multiple collapse-tags clearable filterable>
            <el-option v-for="(item, ind) in authorList" :key="ind" :label="item.realname" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col :md="6" :sm="12">
        <el-form-item label="增长协作者">
          <el-select placeholder="请选择" v-model="searchForm.collaborator" multiple collapse-tags clearable filterable>
            <el-option v-for="(item, ind) in authorList" :key="ind" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="商业化协作者">
          <el-select placeholder="请选择" v-model="searchForm.commercialization" multiple collapse-tags clearable filterable>
            <el-option v-for="item in authorList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-button @click="initFrom" type="primary" slot="btn-option">清除筛选</el-button>
    </FilterLayout>
    <!-- 数据报表 -->
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableData.currentPage" :params="outPamrms" :author="'new'" :leadOut="true" alignStyle="center"
      @pageChange="onPageChange" @sizeChange="onSizeChange" @sortChange="onSortChange" @leadOutClick="leadOutClick"
      :defaultSort="sort" :tableType="tableType">
      <!-- leadApi="Business/report" -->
      <!-- <div class="component_title" slot="title">数据报表</div> -->
      <el-button @click="goAdd" slot="table-option" type="primary">新增记录</el-button>

      <!-- 版本号 -->
      <template #version="{row}">
        <el-link type="primary" @click="jumpOdd(row)">{{ row.version }}</el-link>
      </template>
      <!-- 操作 -->
      <template #option="scope">
        <el-link :underline="false" style="margin-right: 40px; color: #1890ff"
          @click="showDeleteBox(scope.row)">删除</el-link>
        <el-link :underline="false" style="color: #1890ff" @click="compile(scope.row)">编辑</el-link>
      </template>
      <!-- 违规处罚 -->
      <template #punish_temp="scope">
        <el-popover placement="top" trigger="hover" width="400" :content="scope.row.punish.cause">
          <span slot="reference" class="overFlow">{{
            scope.row.punish.cause
          }}</span>
        </el-popover>
      </template>
      <!-- 违规处罚的原件截图 -->
      <template #screenshotPub="scope">
        <div style="
            width: 120px;
            height: 100px;
            margin: 0 auto 5px;
            border-radius: 6px;
            cursor: pointer;
          " @click="visDialog(scope.row.punish.image)" v-show="scope.row.punish.image.length !== 0">
          <!-- :preview-src-list="scope.row.punish.image" -->
          <el-image style="width: 100%; height: 100%; object-fit: contain" :src="scope.row.punish.image[0]"></el-image>
        </div>

        <span v-show="scope.row.punish.image.length !== 0" style="font-size: 12px; text-align: center">点击图片进行预览</span>
      </template>

      <!-- 违规原因 -->
      <template #violation_case="scope">
        <el-popover placement="top" trigger="hover" width="400" :content="scope.row.violation.cause">
          <span slot="reference" class="overFlow">{{
            scope.row.violation.cause
          }}</span>
        </el-popover>
      </template>

      <!-- 违规原因的原件截图 -->
      <template #screenshot="scope">
        <div style="
            width: 120px;
            height: 100px;
            margin: 0 auto 5px;
            border-radius: 6px;
            cursor: pointer;
          " v-show="scope.row.violation.image.length !== 0" @click="visDialog(scope.row.violation.image)">
          <el-image style="width: 100%; height: 100%; object-fit: contain" :src="scope.row.violation.image[0]"></el-image>
        </div>
        <span v-show="scope.row.violation.image.length !== 0" style="font-size: 12px; text-align: center">点击图片进行预览</span>
      </template>

      <!-- 产品功能更新 -->
      <template #renew_content="scope">
        <el-popover trigger="hover" placement="top" width="400" :content="scope.row.renew_content">
          <span slot="reference" class="overFlow">{{
            scope.row.renew_content
          }}</span>
        </el-popover>
      </template>
      <!-- 隐私链接 -->
<!--       <template #privacy_link="scope">
        <el-link :underline="false" target="_blank" :href="scope.row.privacy_link?scope.row.privacy_link:''">{{ scope.row.privacy_link?scope.row.privacy_link:"-" }}</el-link>
      </template> -->
      <!-- 权限隐私更新 -->
      <template #privacy_link="scope">
        <el-popover trigger="hover" placement="top" width="400" :content="scope.row.privacy_link">
          <div slot="reference" class="overFlow">
            <div v-for="item in scope.row.privacy_link.split('\n')" :key="item" style="text-align: left;">
              {{ item }}
            </div>
          </div>
        </el-popover>
      </template>
      <!-- 会员广告更新 -->
      <template #member_adv="scope">
        <el-popover trigger="hover" placement="top" width="400" :content="scope.row.member_adv">
          <span slot="reference" class="overFlow">{{
            scope.row.member_adv
          }}</span>
        </el-popover>
      </template>
      <!-- 中台统计更新 -->
      <template #centre_sdk_up="scope">
        <el-popover placement="top" trigger="hover" width="400" :content="scope.row.centre_sdk_up">
          <span slot="reference" class="overFlow">{{
            scope.row.centre_sdk_up
          }}</span>
        </el-popover>
      </template>

      <!-- 审核异常平台 -->
      <template #err_platform_text="scope">
        <el-popover placement="top" trigger="hover" width="200" :content="scope.row.err_platform_text">
          <span slot="reference" class="overFlow" style="white-space: pre;">{{
            scope.row.err_platform_text
          }}</span>
        </el-popover>
      </template>

      <!-- 备注 -->
      <template #remarks="scope">
          <el-popover placement="top" trigger="hover" width="400" :content="scope.row.remarks">
          <span class="overFlow" slot="reference" v-html="scope.row.remarks"  style="white-space: pre;"></span>
        </el-popover>
      </template>
    </TableLayout>
    <!-- <el-dialog :visible.sync="dialogVis" top="9vh"> -->
    <imagePreview :dialogImage="dialogImage" :firstImage="firstImage" title="原件截图" top="9vh" v-model="dialogVis" />
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import { Mydata } from "./mixins/index";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectCustomize from "@/component/select-customize";
import SelectCustomizeNew from "@/component/select-customize-new";
// import { type } from "os";
// import {imagePreview} from '../component/image-preview.vue'
export default {
  mixins: [Mydata],
  components: {
    FilterLayout,
    SelectCustomize,
    SelectCustomizeNew,
    TableLayout,
    imagePreview: () => import("../component/image-preview.vue"),
  },
  computed: {
    outPamrms() {
      // const { searchForm, tableOpt } = this;
      const { searchForm, tableData } = this;
      return {
        ...searchForm,
        ...tableData,
        // ...tableOpt
      };
    },
  },
  data() {
    return {
      that: this, //保留this选项
      // 表格的筛选项
      searchForm: {
        project: [], //项目
        appid: [], //应用
        system: [], //系统
        channe: [], //渠道
        versionNum: [], //版本号
        auditException: [], //审核异常平台
        responsible: [], //产品负责人
        collaborator: [], //增长协作者
        commercialization: [], //商业化协作者
        timeType: "1", //时间周期
        time: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ], //时间
      },
      projectInfo: {
        appInfo: [], //部门-组件件初始数据
      },
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      systemInfo: {
        appInfo: [], //系统-组件列表数据
      },
      apps: [], //应用-组件回调所选值
      article_id: [], //项目-组件回调所选值
      department_id: [], //事业群数据
      group_id: [], //部门数据
      // 表格数据
      tableData: {
        data: [], //表格总数据
        total: 0, //总数
        lead_out_total_page: 0, // 导出的总页数
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        loading: false, //加载标杆
      },
      // 排序
      sort: {
        prop: "",
        order: "",
      },
      // 表格样式
      tableType: "default",
      versionDisabled: true, //版本号的禁用状态
      versionPopover: false, //版本号(仅一个应用选择时可选的)提示消息的状态改变
      authorList: [], //负责人列表(产品负责人,增长协作者,商业化协作者)
      invest_channels: [], //审核异常平台列表
      versionV2: [], //版本号列表
      second_channels: [], //渠道分类主字段
      cascaderProps: {
        value: "id",
        label: "title",
        children: "children",
        multiple: false,
        expandTrigger: "hover",
      },
      channelsSecond: "",
      dialogVis: false,
      dialogImage: [], //存放弹窗中的数据
      firstImage: "", //第一张图片源
      previewImgIndex: 0,
    };
  },
  created() {
    this.logDeveloper({
      web: '高浩宇',
      back: "刘强"
    })
  },
  async mounted() {
    // await this.getClassify();
    // 初始化调用事业群分组
    await this.getRoleBtree();
    //请求负责人列表
    await this.getAuthor();
    //获取发版列表
    await this.getList();
  },
  methods: {
    //跳转异常
    jumpOdd(row){
      const routeLink = this.$router.resolve({
        path: `/business_center/subsidiary_management/app_auditing?appid=${row.appid}&version=${row.version}&componentName=Auditingunusual&id=33`
      })
      window.open(routeLink.href, '_blank')
    },
    leadOutClick(callBack) {
      this.getList(callBack)
    },
    // leadOutFun(callBack) {
    //   this.getList(callBack);
    // },
    //获取渠道分类
    async getClassify() {
      this.tableData.loading = true;
      let res = await this.$http.post("Invest_Statistics/classify");
      this.second_channels = res[1];
      this.second_channels.forEach(({ id }) => {
        this.getChannel(id);
      });
    },
    async getChannel(id) {
      let [err, res] = await this.$http.post(
        "Invest_Statistics/invest_channels",
        { classify_id: id }
      );
      if (err) return;
      if (id == 1) {
        // this.second_channels[0].children = res[1]
        this.$set(this.second_channels[0], "children", res);
      } else if (id == 2) {
        this.$set(this.second_channels[1], "children", res);
      } else if (id == 4) {
        this.$set(this.second_channels[2], "children", res);
      }
    },
    //获取表单数据
    async getList(callBack) {
      this.tableData.loading = true;
      let leadOutData = [];

      let { currentPage, pageSize } = this.tableData;
      let {
        time,
        project,
        system,
        appid,
        versionNum,
        responsible,
        collaborator,
        commercialization,
      } = this.searchForm;
      // let { order, prop } = this.sort;
      let api = "/release/list";
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        date: {
          start_date: time[0] || "",
          end_date: time[1] || "",
        },
        project_id: project || [],
        system: system || [],
        appid: appid || [],
        version: versionNum || "",
        err_platform: this.channelsSecond || "",
        product_admin_id: responsible || [],
        increase_admin_id: collaborator || [],
        commerce_admin_id: commercialization || [],
        // order: order || "",
        // field: prop || "",
        is_download: callBack ? 1 : undefined,
      };

      // 正常请求接口
      if (!callBack) {
        let [err, res] = await this.$http.post(api, {
          ...params,
          order: this.sort.order,
          field: this.sort.prop,
        });
        if (err) return;
        this.tableData.loading = false;
        if (res.list) {
          this.tableData.data = await this.delData(res.list);
        } else {
          this.tableData.data = [];
        }

        this.tableData.total = res.total;
        // 算出导出总共的页数，如果后端有返回就不用算了
        this.tableData.lead_out_total_page = Math.ceil(res.total / 1000);
      }

      // 导出请求接口
      if (callBack) {
        for (let i = 0; i < this.tableData.lead_out_total_page; i++) {
          const [err, res] = await this.$http.post(api, {
            ...params,
            currentPage: i + 1,
            order: "",
            field: "",
          });
          if (err) return;
          if (res.list) {
            leadOutData.push(...res.list);
          }
        }
        if (leadOutData.length > 0) {
          const del_ok_data = await this.delData(leadOutData);
          this.tableData.loading = false;
          callBack.success(del_ok_data);
        } else {
          this.tableData.loading = false;
          callBack.fail();
        }
      }

      //
    },
    // 处理数据
    delData(data) {
      return new Promise((resolve, reject) => {
        for (const i of data) {
          i.app_name_text = i.app_name + "_" + this.getplatform(i.system);
          i.date = i.date.split(" ")[0];
          // i.commerce_admin_id_text = this.getauthor(i.commerce_admin_id);
          i.product_admin_id_text = this.getauthor(i.product_admin_id);
          // i.increase_admin_id_text = this.getauthor(i.increase_admin_id);
          // i.err_platform_text = this.geterrPlatform(i.err_platform);
          // i.punish_temp = i.punish.cause;
          // i.violation_case = i.violation.cause;
          // if (i.violation.image.length > 1) {
          //   i.screenshot = `${i.violation.image
          //     .join(",")
          //     .replaceAll(",", "\n")}`;
          // } else {
          //   i.screenshot = i.violation.image;
          // }
          // if (i.punish.image.length > 1) {
          //   i.screenshotPub = `${i.punish.image
          //     .join(",")
          //     .replaceAll(",", "\n")}`;
          // } else {
          //   i.screenshotPub = i.punish.image;
          // }
        }
        resolve(data);
      });
    },

    //设备过滤器
    getplatform(val) {
      let plat = "";
      if (val == 1) {
        plat = "android";
      } else if (val == 2) {
        plat = "ios";
      } else if (val == 3) {
        plat = "微信小程序";
      } else if (val == 4) {
        plat = "百度小程序";
      }
      return plat;
    },
    //审核异常平台过滤
    geterrPlatform(val) {
      let arr = [];

      arr = val.split(",");
      if (arr.length > 1) {
        let newArr = [];
        arr.forEach((items) => {
          this.second_channels.forEach(({ children }) => {
            if (children) {
              children.forEach((item) => {
                if (items == item.id) {
                  newArr.push(item.title);
                }
              });
            }

          });
        });
        return Array.from(new Set(newArr)).join(",");
      } else {
        let newPlat = "";
        this.second_channels.forEach(({ children }) => {
          if (children) {
            children.forEach((item) => {
              if (val == item.id) {
                newPlat = item.title;
              }
            });
          }
        });
        return newPlat;
      }
    },
    //负责人过滤
    getauthor(val) {
      let auth = "";
      this.authorList.forEach(({ id, realname }) => {
        if (val == id) {
          auth = realname;
        }
      });
      return auth;
    },

    //获取负责人列表
    async getAuthor() {
      let res = await this.$http.post("Operate_Invest/getAuthor");
      this.authorList = res[1].admin;
    },

    // 获取app事业群分组
    async getRoleBtree() {
      // roleBtree
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.department_id = res.tree

      //应用添加设备分类字段
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      this.departDatas = [
        ...res.list,
        { id: 1005, title: "系统", node: [...this.systemIds] },
      ];
      let group_id = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          group_id.push(_item);
        });
      });
      this.group_id = group_id;
      let apps = [];
      let article_id_arr = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          article_id_arr.push(..._item.node);
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });

      this.apps = apps;
      localStorage.setItem("appinfo", JSON.stringify(this.apps));
      this.article_id = article_id_arr;
      localStorage.setItem("projectInfo", JSON.stringify(this.article_id));
    },
    // 改变项目
    changeArticle(val) {
      this.searchForm.project = val.appInfo;
      this.searchForm.appid = [];
      this.appidInfo.appInfo = [];
      let apps_arr = [];
      if (this.searchForm.project.length) {
        this.searchForm.project.forEach((item) => {
          this.department_id.forEach((_item) => {
            _item.node.forEach((__item) => {
              __item.node.forEach((item_) => {
                if (item == item_.id) {
                  apps_arr.push(...item_.node);
                }
              });
            });
          });
        });
      } else {
        this.article_id.forEach((item) => {
          apps_arr.push(...item.node);
        });
      }
      this.apps = apps_arr;
    },
    // 筛选应用的回调函数
    changeAppid(val) {
      this.searchForm.appid = val.appInfo;
      if (val.appInfo.length == 1) {
        //获取版本号
        this.getVersionV2(val.optionList[0].id);
        this.versionDisabled = false;
        this.versionPopover = true;
      } else {
        this.versionDisabled = true;
        this.versionPopover = false;
      }
    },
    //获取版本号
    async getVersionV2(id) {
      let res = await this.$http.post("App/getVersionV2", { appId: id });
      this.versionV2 = Array.from(new Set(res[1]));
    },
    // 筛选系统的回调函数
    changeSystem(val) {
      this.searchForm.system = val.appInfo;
    },
    // 表单查询
    onSubmit() {
      this.tableData.currentPage = 1
      this.sort.prop = "";
      this.sort.order = "";
      this.getList();
    },
    // 重置表单
    initFrom() {
      this.projectInfo.appInfo = [];
      this.appidInfo.appInfo = [];
      this.systemInfo.appInfo = [];
      this.channelsSecond = "";
      this.searchForm = {
        //筛选项
        appid: [],
        system: [],
        timeType: "1",
        time: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
        versionNum: [],
        auditException: [],
        responsible: [],
        collaborator: [],
        commercialization: [],
      };
    },
    // 每页改变回调
    onPageChange(current) {
      this.tableData.currentPage = current;
      this.sort.order = "";
      this.sort.prop = "";
      this.getList();
    },
    // 每页条数改变回调
    onSizeChange(current) {
      this.tableData.pageSize = current;
      this.sort.order = "";
      this.sort.prop = "";
      this.getList();
    },
    // 表格排序的回调
    onSortChange(data) {
      if (data.order == "descending") {
        this.sort.order = data.order.substring(0, 4);
        this.sort.prop = data.prop;
        this.getList();
      } else if (data.order == "ascending") {
        this.sort.order = data.order.substring(0, 3);
        this.sort.prop = data.prop;
        this.getList();
      } else {
        this.sort.roder = "";
        this.sort.prop = data.prop;
      }
    },
    // 跳转新增记录
    goAdd() {
      this.$router.push({
        path: "/business_center/subsidiary_management/index_add",
        query: {
          apps: this.apps,
        },
      });
    },
    //打开表单中的删除确认框
    showDeleteBox(row) {
      this.$confirm("此操作不可逆转,是否删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http.post("release/del", { id: row.id }).then((res) => {
            if (res[3] == "success") {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.warning("删除失败,请稍后再试");
            }
          });
        })
        .catch(() => {
          this.$message.warning("已取消删除");
        });
    },
    //表单中的编辑
    compile(row) {
      localStorage.setItem("details", JSON.stringify(row));
      this.$router.push({
        path: "/business_center/subsidiary_management/index_add",
      });
    },
    //联动选择
    cascderChange(val) {
      this.channelsSecond = val[1];
    },
    //打开弹窗
    visDialog(img) {
      this.dialogImage = img;
      this.firstImage = img[0];
      this.dialogVis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.top-box {
  margin-bottom: 20px;

  .btn {
    margin-top: 20px;
  }
}

.component_title2 {
  background: #fff;
  padding: 1px 0 10px 15px;
  font-weight: bold;
}

.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}

.font14 {
  font-size: 14px;
}

.Tab_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  button {
    margin-right: 20px;
  }

  .left_box {
    line-height: 40px;
    // width: 1000px;
    display: flex;

    .btns {
      margin-left: 20px;
    }
  }
}

.my-select {
  height: 40px;
}

.check-all {
  padding: 0 20px;
  text-align: right;
}

.overFlow {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

</style>

<style>
.el-popover{
  white-space: break-spaces !important;
}
</style>
